import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Primitives";
import { DownloadSimple } from "@phosphor-icons/react";

export default function StudentMaterials() {
  const [materials, setMaterials] = useState([]);

  const load = () => api.get("/materials").then(r => setMaterials(r.data));
  useEffect(() => { load(); }, []);

  const open = async (m) => {
    await api.post(`/materials/${m.id}/download`);
    window.open(m.file_url, "_blank");
    load();
  };

  return (
    <div>
      <PageHeader eyebrow="Library" title="Study material" subtitle="Notes, PPTs, recorded lectures shared by your faculty." />
      {materials.length === 0 ? <EmptyState /> : (
        <div className="grid md:grid-cols-2 gap-4">
          {materials.map(m => (
            <div key={m.id} className="card-academic p-5">
              <div className="overline">{m.type} · {m.class_group}</div>
              <h4 className="font-serif text-xl text-forest mb-2">{m.title}</h4>
              {m.description && <p className="text-sm text-mossy mb-3">{m.description}</p>}
              <div className="flex items-center justify-between">
                <div className="text-xs font-mono text-mossy flex items-center gap-1"><DownloadSimple size={12} /> {m.download_count} opens</div>
                <button onClick={() => open(m)} className="btn-ghost text-xs flex items-center gap-2" data-testid={`open-mat-${m.id}`}>
                  <DownloadSimple size={14} /> Open
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
